import { Injectable } from "@angular/core";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { ApiService } from "@edp-services/api.service";
import { Observable, Subject } from "rxjs";
import { ApiEsService } from "./api-es.service";

@Injectable({
    providedIn: "root",
})
export class ContractEsService {
    constructor(private apiEsService: ApiEsService) {}

    public getAll(args: any = {}): Observable<ContractEs[] | Error> {
        return this.apiEsService.callServicePostToCollection("solar.services.contract.getContracts", args);
    }

}
